(function () {
  var allowedPromos = [
    'oils5',
    'essential20',
    'laborday40'
  ];

  var params = new URLSearchParams(window.location.search);
  var promo = params.get('promo');

  if (promo && allowedPromos.includes(promo)) {
    sessionStorage.setItem('active_promo', promo);
  }

  var activePromo = sessionStorage.getItem('active_promo');

  if (!activePromo || !allowedPromos.includes(activePromo)) {
    return;
  }

  function applyPromoClasses() {
    document.documentElement.classList.add('promo-active');
    document.documentElement.classList.add(
      'promo-' + activePromo + '-active'
    );

    if (document.body) {
      document.body.classList.add('promo-active');
      document.body.classList.add(
        'promo-' + activePromo + '-active'
      );
    }
  }

  applyPromoClasses();

  if (!document.body) {
    document.addEventListener('DOMContentLoaded', applyPromoClasses);
  }
})();